import { render, staticRenderFns } from "./certificate-drawer.vue?vue&type=template&id=438ba073&"
import script from "./certificate-drawer.vue?vue&type=script&lang=js&"
export * from "./certificate-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports